module.exports = __webpack_public_path__ + "static/media/services.53b2f304.jpg";